import { render, staticRenderFns } from "./ICSAdvanced.vue?vue&type=template&id=2bc10bbb&scoped=true"
import script from "./ICSAdvanced.vue?vue&type=script&lang=js"
export * from "./ICSAdvanced.vue?vue&type=script&lang=js"
import style0 from "./ICSAdvanced.vue?vue&type=style&index=0&id=2bc10bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc10bbb",
  null
  
)

export default component.exports